import { MaintenanceState } from '../../../components/MaintenanceState/MaintenanceState';
import { TertiaryNavigation } from '../../../components/TertiaryNavigation/TertiaryNavigation';
import { TertiaryFeature } from '../../../utils/types';
import { MySupplierPage } from './MySupplierPage/MySupplierPage';
import { PowerBiReport } from '../../../components/PowerBiReport';
import { useNavigationContext } from '../../../context/NavigationProvider';

export const CustomerPortalInsights: React.FC = () => {
  const { secondaryFeature } = useNavigationContext();

  return (
    <TertiaryNavigation>
      {secondaryFeature?.tertiaryFeatures?.find(
        ({ id }) =>
          id ===
          TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_PRODUCT_VIEWS,
      ) && (
        <TertiaryNavigation.Item
          id={TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_PRODUCT_VIEWS}
        >
          {secondaryFeature?.tertiaryFeatures?.find(
            ({ id }) =>
              id ===
              TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_PRODUCT_VIEWS,
          )?.maintenanceMode ? (
            <MaintenanceState />
          ) : (
            <PowerBiReport />
          )}
        </TertiaryNavigation.Item>
      )}
      {secondaryFeature?.tertiaryFeatures?.find(
        ({ id }) =>
          id ===
          TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_MY_SUPPLIER_PAGE,
      ) && (
        <TertiaryNavigation.Item
          id={
            TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_MY_SUPPLIER_PAGE
          }
        >
          {secondaryFeature?.tertiaryFeatures?.find(
            ({ id }) =>
              id ===
              TertiaryFeature.INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_MY_SUPPLIER_PAGE,
          )?.maintenanceMode ? (
            <MaintenanceState />
          ) : (
            <MySupplierPage />
          )}
        </TertiaryNavigation.Item>
      )}
    </TertiaryNavigation>
  );
};
